import { useState } from "react"
import { Table } from "reactstrap"

const ChackOnOf = ({
  chackData,
  onFilterChange,
  variant = 'table'
}: {
  chackData: any[],
  onFilterChange: (filter: 'all' | 'online' | 'offline') => void,
  variant?: 'table' | 'cards'
}) => {
  const [selectedChak, setSelectedChak] = useState<string>('all')

  let online = 0;
  let offline = 0;

  chackData.forEach((data: any) => {
    const apiTime = new Date(String(data.dateTime).replace(' ', 'T'));
    const currentTime = new Date();
    const diffHours = (currentTime.getTime() - apiTime.getTime()) / (1000 * 60 * 60);

    if (diffHours > 6) {
      offline++;
    } else {
      online++;
    }
  });

  const handleClick = (filter: 'all' | 'online' | 'offline') => {
    setSelectedChak(filter)
    onFilterChange(filter)
  }

  // ===== naya cards variant, sirf OmsList jaise callers k liye =====
  if (variant === 'cards') {
    const cardStyle = (active: boolean, color: string) => ({
      cursor: 'pointer',
      padding: '4px 12px',
      borderRadius: '8px',
      textAlign: 'center' as const,
      minWidth: '60px',
      border: `1px solid ${active ? color : '#e2e2e2'}`,
      backgroundColor: active ? color : '#fff',
      transition: 'all 0.15s ease',
      boxShadow: active ? `0 1px 4px ${color}55` : '0 1px 2px rgba(0,0,0,0.05)',
    })

    const labelStyle = (active: boolean) => ({
      fontSize: '13px',
      fontWeight: 600,
      textTransform: 'lowercase' as const,
      letterSpacing: '0.3px',
      color: active ? '#fff' : '#8a8a8a',
      marginBottom: '0px',
    })

    const valueStyle = (active: boolean) => ({
      fontSize: '12px',
      fontWeight: 600,
      color: active ? '#fff' : '#333',
      lineHeight: 1.1,
    })

    return (
      <div style={{ display: 'flex', gap: '6px' }}>
        <div style={cardStyle(selectedChak === 'all', '#1e563d')} onClick={() => handleClick('all')}>
          <div style={labelStyle(selectedChak === 'all')}>Total</div>
          <div style={valueStyle(selectedChak === 'all')}>{chackData.length}</div>
        </div>

        <div style={cardStyle(selectedChak === 'online', '#28a745')} onClick={() => handleClick('online')}>
          <div style={labelStyle(selectedChak === 'online')}>Online</div>
          <div style={valueStyle(selectedChak === 'online')}>{online}</div>
        </div>

        <div style={cardStyle(selectedChak === 'offline', '#dc3545')} onClick={() => handleClick('offline')}>
          <div style={labelStyle(selectedChak === 'offline')}>Offline</div>
          <div style={valueStyle(selectedChak === 'offline')}>{offline}</div>
        </div>
      </div>
    )
}

  // ===== purana table variant, jaha pehle se use ho raha hai wahi rahega =====
  return (
    <>
      <Table>
        <thead className="bg-light-primary">
          <tr>
            <th style={{ cursor: 'pointer', fontWeight: '500', fontSize: '14px' }} onClick={() => { onFilterChange('all') }}><strong>Total Chaks</strong></th>
            <th style={{ cursor: 'pointer', fontWeight: '500', fontSize: '14px' }} onClick={() => onFilterChange('online')}><strong>Online</strong></th>
            <th style={{ cursor: 'pointer', fontWeight: '500', fontSize: '14px' }} onClick={() => onFilterChange('offline')}><strong>Offline</strong></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{
              cursor: 'pointer', fontSize: '16px',
              ...(selectedChak == 'all' ? {
                backgroundColor: '#E2DFD2',
                color: 'black',
                borderRadius: '50px',
                textAlign: 'center'
              } : '')
            }} onClick={() => { onFilterChange('all'); setSelectedChak('all') }}>{chackData.length}</td>
            <td onClick={() => { onFilterChange('online'); setSelectedChak('online') }} style={{
              color: "green", cursor: 'pointer',
              fontSize: '16px',
              ...(selectedChak == 'online' ? {
                backgroundColor: 'green',
                color: 'white',
                borderRadius: '50px',
                textAlign: 'center'
              } : '')
            }}>{online}</td>
            <td onClick={() => { onFilterChange('offline'); setSelectedChak('offline') }} style={{
              color: "red", cursor: 'pointer', fontSize: '16px', ...(selectedChak == 'offline' ? {
                backgroundColor: 'red',
                color: 'white',
                borderRadius: '50px',
                textAlign: 'center'
              } : '')
            }}>{offline}</td>
          </tr>
        </tbody>
      </Table>
    </>
  );
};

export default ChackOnOf;